import React from 'react';
import { Box, Container, Typography, Stack, Link } from '@mui/material';
import { landingThemeConfig } from '../styles/landingThemeConfig';
import { links } from '../../../config/links';

const MinimalFooter = ({ colorTheme = 'teal', onEducatorClick }) => {
  const studentTheme = landingThemeConfig.student(colorTheme);

  const handleEducatorClick = (e) => {
    e.preventDefault();
    if (onEducatorClick) {
      onEducatorClick();
    }
  };

  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        borderTop: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'transparent',
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'center', sm: 'flex-start' }}
          spacing={4}
        >
          {/* Left side - Logo and copyright */}
          <Box textAlign={{ xs: 'center', sm: 'left' }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                background: `linear-gradient(45deg, ${studentTheme.components.hero.titleGradientStart} 30%, ${studentTheme.components.hero.titleGradientEnd} 90%)`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                mb: 1,
              }}
            >
              examr
            </Typography>
            <Typography variant="body2" color="text.secondary">
              © 2024 examr. All rights reserved.
            </Typography>
          </Box>

          {/* Right side - Links */}
          <Stack
            direction="row"
            spacing={3}
            sx={{
              flexWrap: 'wrap',
              justifyContent: { xs: 'center', sm: 'flex-end' },
            }}
          >
            <Link
              href={links.internal.privacy}
              color="text.secondary"
              underline="hover"
              sx={{
                transition: 'color 0.2s',
                '&:hover': { color: 'primary.main' },
              }}
            >
              Privacy
            </Link>
            <Link
              href={links.internal.contact}
              color="text.secondary"
              underline="hover"
              sx={{
                transition: 'color 0.2s',
                '&:hover': { color: 'primary.main' },
              }}
            >
              Contact
            </Link>
            <Link
              href="#"
              onClick={handleEducatorClick}
              color="primary.main"
              underline="hover"
              sx={{
                fontWeight: 600,
                transition: 'opacity 0.2s',
                '&:hover': { opacity: 0.8 },
              }}
            >
              Are you an educator?
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default MinimalFooter;